import React, { useState, useEffect, useCallback, useRef } from 'react';
import { BandeauProvider, useBandeau } from './BandeauContext';
import { Sparkles, Bot, Calendar } from 'lucide-react';
import EtudiantView from './student/EtudiantView';
import CourseView    from './student/CourseView';
import AdminContent        from './admin/AdminContent';
import AdminSkills         from './admin/AdminSkills';
import AdminStudents       from './admin/AdminStudents';
import AdminUploads        from './AdminUploads';
import AdminStats          from './admin/AdminStats';
import AdminMedia          from './admin/AdminMedia';
import ProfesseurClasses   from './professeur/ProfesseurClasses';
import ProfesseurProgres   from './professeur/ProfesseurProgres';
import ParentDashboard     from './parent/ParentDashboard';
import Messagerie          from './Messagerie';
import ProfileSettings from './ProfileSettings';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { apiClient } from '../utils/apiClient';
import AxiomusLogo from './AxiomusLogo';

// ─── Icônes ───────────────────────────────────────────────────────────────────
const IconHome     = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
const IconCalendar = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IconBook     = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/></svg>;
const IconMenu     = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/></svg>;
const IconX        = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>;
const IconUser     = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IconLogout   = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" x2="9" y1="12" y2="12"/></svg>;
const IconHistory  = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IconImage    = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>;
const IconUsers    = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IconSparkle  = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5z"/><path d="M19 3l.75 2.25L22 6l-2.25.75L19 9l-.75-2.25L16 6l2.25-.75z"/><path d="M5 17l.75 2.25L8 20l-2.25.75L5 23l-.75-2.25L2 20l2.25-.75z"/></svg>;
const IconFolder   = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>;
const IconGrades   = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>;

// ─── Config navigation par rôle ───────────────────────────────────────────────
const NAV = {
    etudiant: [
        { path: '/',          label: 'Accueil',  Icon: IconHome, exact: true },
        { path: '/apprendre', label: 'Apprendre', Icon: IconBook, activePaths: ['/apprendre', '/exercice'] },
        { path: '/agenda',    label: 'Agenda',   Icon: IconCalendar, activePaths: ['/agenda', '/planning'] },
        { path: '/notes',     label: 'Notes',    Icon: IconGrades },
    ],
    admin: [
        { path: '/apprendre',    label: 'Apprendre',    Icon: IconBook,    activePaths: ['/apprendre'] },
        { path: '/admin/eleves', label: 'Utilisateurs', Icon: IconUsers },
        { path: '/admin/images', label: 'Images',       Icon: IconImage },
        { path: '/admin/medias', label: 'Médiathèque',  Icon: IconFolder },
    ],
    supertuteur: [
        { path: '/apprendre',    label: 'Apprendre', Icon: IconBook,  activePaths: ['/apprendre'] },
        { path: '/admin/eleves', label: 'Élèves',    Icon: IconUsers },
    ],
    tuteur: [
        { path: '/admin/eleves', label: 'Élèves', Icon: IconUsers },
    ],
    professeur: [
        { path: '/professeur/classes', label: 'Classes', Icon: IconUsers,   exact: true },
        { path: '/professeur/progres', label: 'Progrès', Icon: IconHistory },
    ],
    parent: [
        { path: '/parent/enfants', label: 'Mes enfants', Icon: IconUsers, exact: true },
    ],
};

const ROLE_BADGE = {
    admin:       { label: 'Admin',       color: 'bg-purple-100 dark:bg-purple-900/40 text-purple-700 dark:text-purple-300' },
    supertuteur: { label: 'Supertuteur', color: 'bg-indigo-100 dark:bg-indigo-900/40 text-indigo-700 dark:text-indigo-300' },
    tuteur:      { label: 'Tuteur',      color: 'bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300' },
    professeur:  { label: 'Professeur',  color: 'bg-teal-100 dark:bg-teal-900/40 text-teal-700 dark:text-teal-300' },
    parent:      { label: 'Parent',      color: 'bg-orange-100 dark:bg-orange-900/40 text-orange-700 dark:text-orange-300' },
    etudiant:    { label: 'Élève',       color: 'bg-cyan-100 dark:bg-cyan-900/40 text-cyan-700 dark:text-cyan-300' },
};

function isActive(item, pathname) {
    if (item.exact) return pathname === item.path;
    if (item.activePaths) return item.activePaths.some(p => pathname.startsWith(p));
    return pathname.startsWith(item.path);
}

// ─── Breadcrumb responsive ────────────────────────────────────────────────────
function SmartBreadcrumb({ crumbs }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;
        const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [open]);

    const chevron = (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="shrink-0 text-gray-300 dark:text-gray-600"><path d="m9 18 6-6-6-6"/></svg>
    );

    const CrumbItem = ({ crumb, onClick }) => crumb.onClick ? (
        <button onClick={onClick ?? crumb.onClick} className="text-[11px] font-medium text-gray-400 dark:text-gray-500 hover:text-blue-600 dark:hover:text-cyan-400 transition-colors leading-none truncate max-w-[120px]">
            {crumb.label}
        </button>
    ) : (
        <span className="text-[11px] font-medium text-gray-400 dark:text-gray-500 leading-none truncate max-w-[120px]">{crumb.label}</span>
    );

    const collapse = crumbs.length > 2;
    const first  = crumbs[0];
    const middle = crumbs.slice(1, -1);
    const last   = crumbs[crumbs.length - 1];

    const homeIcon = (
        <Link to="/" className="text-gray-400 dark:text-gray-500 hover:text-blue-600 dark:hover:text-cyan-400 transition-colors flex items-center shrink-0">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
        </Link>
    );

    return (
        <nav className="flex items-center gap-1 mb-1 min-w-0">
            {homeIcon}

            {/* Desktop : tous les crumbs */}
            <span className="hidden md:contents">
                {crumbs.map((crumb, i) => (
                    <React.Fragment key={i}>
                        {chevron}
                        <CrumbItem crumb={crumb} />
                    </React.Fragment>
                ))}
            </span>

            {/* Mobile : premier > … > dernier si > 2, sinon tout afficher */}
            <span className="contents md:hidden">
                {!collapse ? crumbs.map((crumb, i) => (
                    <React.Fragment key={i}>
                        {chevron}
                        <CrumbItem crumb={crumb} />
                    </React.Fragment>
                )) : (
                    <>
                        {chevron}
                        <CrumbItem crumb={first} />
                        {chevron}
                        <div ref={ref} className="relative shrink-0">
                            <button
                                onClick={() => setOpen(o => !o)}
                                className={`text-[11px] font-bold px-1.5 py-0.5 rounded-md transition-colors leading-none ${open ? 'bg-gray-100 dark:bg-white/10 text-cyan-600 dark:text-cyan-400' : 'text-gray-400 dark:text-gray-500 hover:bg-gray-100 dark:hover:bg-white/10 hover:text-gray-600 dark:hover:text-gray-300'}`}
                            >
                                •••
                            </button>
                            {open && (
                                <div className="absolute top-full left-0 mt-1.5 min-w-[160px] bg-white dark:bg-gray-900 rounded-xl shadow-2xl border border-gray-200 dark:border-white/10 py-1 z-[300]">
                                    {middle.map((crumb, i) => (
                                        <button key={i} onClick={() => { crumb.onClick?.(); setOpen(false); }}
                                            className="w-full text-left flex items-center gap-2 px-3 py-2 text-xs text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-white/[0.05] transition-colors">
                                            {chevron}
                                            <span className="truncate">{crumb.label}</span>
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                        {chevron}
                        <CrumbItem crumb={last} />
                    </>
                )}
            </span>
        </nav>
    );
}

// ─── Bandeau flottant (lit le contexte injecté par les pages) ─────────────────
function BandeauContent({ user, location, navigate, onLogout, renderContent }) {
    const { override } = useBandeau();
    const [openDropdown, setOpenDropdown] = useState(null); // 'messages' | 'notifs' | 'profile' | null
    const [bandeauData, setBandeauData]   = useState({ messages: { unread: 0, conversations: [] }, notifications: { unread: 0, items: [] } });
    const dropdownRef = useRef(null);

    // Fetch messages + notifs counts
    const fetchBandeauData = useCallback(() => {
        apiClient(`${process.env.REACT_APP_API_BASE_URL}/get_bandeau_data.php`)
            .then(r => r.json())
            .then(d => { if (d.success) setBandeauData(d); })
            .catch(() => {});
    }, []);

    useEffect(() => {
        fetchBandeauData();
        const id = setInterval(fetchBandeauData, 60000);
        window.addEventListener('bandeau-refresh', fetchBandeauData);
        return () => {
            clearInterval(id);
            window.removeEventListener('bandeau-refresh', fetchBandeauData);
        };
    }, [fetchBandeauData]);

    // Close dropdown on outside click
    useEffect(() => {
        if (!openDropdown) return;
        const handler = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setOpenDropdown(null);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [openDropdown]);

    const toggle = (name) => setOpenDropdown(prev => prev === name ? null : name);

    const markAllNotifsRead = () => {
        apiClient(`${process.env.REACT_APP_API_BASE_URL}/notifications.php?action=mark_read`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({}) })
            .then(() => setBandeauData(prev => ({ ...prev, notifications: { ...prev.notifications, unread: 0, items: prev.notifications.items.map(n => ({ ...n, is_read: '1' })) } })))
            .catch(() => {});
    };

    const timeAgo = (ts) => {
        if (!ts) return '';
        const diff = Math.floor((Date.now() - new Date(ts.replace(' ', 'T')).getTime()) / 1000);
        if (diff < 60) return 'à l\'instant';
        if (diff < 3600) return `${Math.floor(diff / 60)} min`;
        if (diff < 86400) return `${Math.floor(diff / 3600)} h`;
        return `${Math.floor(diff / 86400)} j`;
    };

    const msgUnread   = bandeauData.messages.unread;
    const notifUnread = bandeauData.notifications.unread;
    const convs       = bandeauData.messages.conversations;
    const notifItems  = bandeauData.notifications.items;

    return (
        <>
            <div className="relative z-[100] max-w-7xl w-full mx-auto px-4 md:px-6 pt-6 pb-0">
                <div className="relative bg-white/70 dark:bg-white/[0.02] backdrop-blur-xl border border-gray-200 dark:border-white/[0.05] rounded-3xl px-6 py-5 flex items-center justify-between gap-4 shadow-sm mb-6">
                    <div className="absolute inset-0 pointer-events-none">
                        <div className="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 bg-cyan-500/10 blur-[80px] rounded-full dark:bg-cyan-500/20" />
                    </div>
                    {/* ── Titre / breadcrumb ──── */}
                    <div className="relative flex flex-col min-w-0">
                        {!override ? (
                            <span className="text-[11px] font-medium text-gray-400 dark:text-gray-500 capitalize leading-none mb-1">
                                {new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })}
                            </span>
                        ) : override.breadcrumb?.length > 0 ? (
                            <SmartBreadcrumb crumbs={override.breadcrumb} />
                        ) : null}
                        <span className="text-2xl font-extrabold text-gray-800 dark:text-white leading-tight truncate">
                            {override?.title ?? (
                                <>Bonjour, <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-400">{user.first_name || user.name}</span> <Sparkles className="w-5 h-5 inline-block text-amber-400 ml-1 animate-pulse" /></>
                            )}
                        </span>
                    </div>

                    {/* ── Boutons droite ──── */}
                    <div ref={dropdownRef} className="relative flex items-center gap-1.5 shrink-0">

                        {/* ── Notifications ──── */}
                        <div className="relative">
                            <button onClick={() => toggle('notifs')}
                                className={`relative w-10 h-10 flex items-center justify-center rounded-2xl transition-colors ${openDropdown === 'notifs' ? 'bg-cyan-500/10 text-cyan-600 dark:text-cyan-400' : 'hover:bg-gray-100 dark:hover:bg-white/[0.06] text-gray-500 dark:text-gray-400'}`}>
                                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                                </svg>
                                {notifUnread > 0 && (
                                    <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-0.5 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center leading-none">
                                        {notifUnread > 9 ? '9+' : notifUnread}
                                    </span>
                                )}
                            </button>
                            {openDropdown === 'notifs' && (
                                <div className="absolute right-0 top-[calc(100%+8px)] w-80 bg-white dark:bg-gray-900 rounded-2xl shadow-2xl border border-gray-200 dark:border-white/10 z-[200] overflow-hidden">
                                    <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 dark:border-white/10">
                                        <span className="text-sm font-semibold text-gray-800 dark:text-white">Notifications</span>
                                        {notifUnread > 0 && (
                                            <button onClick={markAllNotifsRead} className="text-xs text-cyan-600 dark:text-cyan-400 hover:underline">Tout marquer lu</button>
                                        )}
                                    </div>
                                    {notifItems.length === 0 ? (
                                        <div className="py-10 text-center text-sm text-gray-400">
                                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="mx-auto mb-2 opacity-40"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
                                            Aucune notification
                                        </div>
                                    ) : (
                                        <div className="max-h-72 overflow-y-auto divide-y divide-gray-100 dark:divide-white/5">
                                            {notifItems.map(n => (
                                                <button key={n.id} onClick={() => { if (n.link) { setOpenDropdown(null); navigate(n.link); } }}
                                                    className={`w-full text-left px-4 py-3 hover:bg-gray-50 dark:hover:bg-white/[0.03] transition-colors flex gap-3 ${n.is_read === '0' || n.is_read === 0 ? 'bg-cyan-50/50 dark:bg-cyan-500/[0.05]' : ''}`}>
                                                    <div className="w-2 h-2 rounded-full mt-1.5 shrink-0" style={{ backgroundColor: n.is_read === '0' || n.is_read === 0 ? '#06b6d4' : 'transparent', border: n.is_read === '0' || n.is_read === 0 ? 'none' : '1px solid #d1d5db' }} />
                                                    <div className="min-w-0 flex-1">
                                                        <p className="text-sm font-medium text-gray-800 dark:text-white truncate">{n.title}</p>
                                                        {n.body && <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5 line-clamp-1">{n.body}</p>}
                                                        <p className="text-[10px] text-gray-400 mt-1">{timeAgo(n.created_at)}</p>
                                                    </div>
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* ── Messagerie ──── */}
                        <div className="relative">
                            <button onClick={() => toggle('messages')}
                                className={`relative w-10 h-10 flex items-center justify-center rounded-2xl transition-colors ${openDropdown === 'messages' || isActive({ path: '/messagerie' }, location.pathname) ? 'bg-cyan-500/10 text-cyan-600 dark:text-cyan-400' : 'hover:bg-gray-100 dark:hover:bg-white/[0.06] text-gray-500 dark:text-gray-400'}`}>
                                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                                </svg>
                                {msgUnread > 0 && (
                                    <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-0.5 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center leading-none">
                                        {msgUnread > 9 ? '9+' : msgUnread}
                                    </span>
                                )}
                            </button>
                            {openDropdown === 'messages' && (
                                <div className="absolute right-0 top-[calc(100%+8px)] w-80 bg-white dark:bg-gray-900 rounded-2xl shadow-2xl border border-gray-200 dark:border-white/10 z-[200] overflow-hidden">
                                    <div className="px-4 py-3 border-b border-gray-100 dark:border-white/10">
                                        <span className="text-sm font-semibold text-gray-800 dark:text-white">Messages</span>
                                    </div>
                                    {convs.length === 0 ? (
                                        <div className="py-10 text-center text-sm text-gray-400">
                                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="mx-auto mb-2 opacity-40"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                                            Aucun message
                                        </div>
                                    ) : (
                                        <div className="divide-y divide-gray-100 dark:divide-white/5">
                                            {convs.map(c => (
                                                <button key={c.id} onClick={() => { setOpenDropdown(null); navigate(`/messagerie?conv=${c.id}`); }}
                                                    className="w-full text-left px-4 py-3 hover:bg-gray-50 dark:hover:bg-white/[0.03] transition-colors flex items-start gap-3">
                                                    <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-cyan-400 to-purple-500 text-white text-xs font-bold flex items-center justify-center shrink-0">
                                                        {(c.other_name || '?')[0].toUpperCase()}
                                                    </div>
                                                    <div className="min-w-0 flex-1">
                                                        <div className="flex items-center justify-between gap-2">
                                                            <span className={`text-sm truncate ${parseInt(c.unread_count) > 0 ? 'font-semibold text-gray-900 dark:text-white' : 'font-medium text-gray-700 dark:text-gray-300'}`}>
                                                                {c.other_name}
                                                            </span>
                                                            <span className="text-[10px] text-gray-400 shrink-0">{timeAgo(c.last_message_at)}</span>
                                                        </div>
                                                        <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5 truncate">{c.last_message || '…'}</p>
                                                    </div>
                                                    {parseInt(c.unread_count) > 0 && (
                                                        <span className="min-w-[18px] h-[18px] px-1 rounded-full bg-cyan-500 text-white text-[10px] font-bold flex items-center justify-center shrink-0">
                                                            {c.unread_count}
                                                        </span>
                                                    )}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                    <div className="px-3 py-2 border-t border-gray-100 dark:border-white/10">
                                        <button onClick={() => { setOpenDropdown(null); navigate('/messagerie'); }}
                                            className="w-full py-2 rounded-xl text-xs font-semibold text-cyan-600 dark:text-cyan-400 hover:bg-cyan-50 dark:hover:bg-cyan-500/10 transition-colors">
                                            Voir toute la messagerie →
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* ── Profil ──── */}
                        <div className="relative">
                            <button onClick={() => toggle('profile')}
                                className={`w-10 h-10 rounded-2xl flex items-center justify-center text-sm font-bold shadow-sm transition-all hover:scale-105 bg-gradient-to-br from-cyan-400 to-purple-500 text-white ${openDropdown === 'profile' || isActive({ path: '/profil' }, location.pathname) ? 'ring-2 ring-offset-2 ring-cyan-400' : ''}`}>
                                {(user.first_name || user.name || '?')[0].toUpperCase()}
                            </button>
                            {openDropdown === 'profile' && (
                                <div className="absolute right-0 top-[calc(100%+8px)] w-56 bg-white dark:bg-gray-900 rounded-2xl shadow-2xl border border-gray-200 dark:border-white/10 z-[200] overflow-hidden">
                                    {/* En-tête */}
                                    <div className="px-4 py-3 border-b border-gray-100 dark:border-white/10">
                                        <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">{user.first_name || user.name}</p>
                                        <p className="text-xs text-gray-400 truncate mt-0.5">{user.email}</p>
                                    </div>
                                    {/* Items */}
                                    <div className="py-1">
                                        <button onClick={() => { setOpenDropdown(null); navigate('/profil'); }}
                                            className="w-full text-left flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-white/[0.04] transition-colors">
                                            <IconUser />
                                            Mon profil
                                        </button>
                                        <button onClick={() => { setOpenDropdown(null); navigate('/abonnement'); }}
                                            className="w-full text-left flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-white/[0.04] transition-colors">
                                            <IconSparkle />
                                            Abonnement
                                        </button>
                                    </div>
                                    <div className="py-1 border-t border-gray-100 dark:border-white/10">
                                        <button onClick={() => { setOpenDropdown(null); onLogout(); }}
                                            className="w-full text-left flex items-center gap-3 px-4 py-2.5 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-500/[0.06] transition-colors">
                                            <IconLogout />
                                            Déconnexion
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </div>
            <div className="flex-1 max-w-7xl w-full mx-auto px-4 md:px-6 pb-6">
                {renderContent()}
            </div>
        </>
    );
}

// ─── Composant ────────────────────────────────────────────────────────────────
function Dashboard({ user, onLogout, isDarkMode, toggleDarkMode, onProfileUpdate }) {
    const { role } = user;
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isLargeScreen, setIsLargeScreen] = useState(() => window.innerWidth >= 1024);
    const location  = useLocation();
    const navigate  = useNavigate();

    // Données agenda (utilisées uniquement pour les étudiants)
    const [upcomingEvents,     setUpcomingEvents]     = useState([]);
    const [futureEvents,       setFutureEvents]       = useState([]);
    const [timeOffset,         setTimeOffset]         = useState(0);
    const [launchedEventIds,   setLaunchedEventIds]   = useState([]);
    const [currentActiveSession, setCurrentActiveSession] = useState(null);

    const fetchUpcomingEvents = useCallback(() => {
        apiClient(`${process.env.REACT_APP_API_BASE_URL}/get_upcoming_events.php?t=${Date.now()}`, { cache: 'no-store' })
            .then(res => res.json())
            .then(data => {
                if (!data.success || !data.events) return;
                const serverTime  = data.server_time ? new Date(data.server_time).getTime() : Date.now();
                const offset      = serverTime - Date.now();
                setTimeOffset(offset);
                const now         = new Date(Date.now() + offset);
                const startOfDay  = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                const endOfDay    = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
                const parseDays   = (rrule) => {
                    const m = (rrule || '').match(/BYDAY=([^;]+)/);
                    if (!m) return [];
                    const map = { SU:0, MO:1, TU:2, WE:3, TH:4, FR:5, SA:6 };
                    return m[1].split(',').map(d => map[d]);
                };
                const eventMap = new Map(data.events.map(e => [e.id, { ...e }]));
                let todayEvents = [], allFuture = [];

                for (const event of data.events) {
                    if (!event.parent_event_id) continue;
                    const parent = eventMap.get(event.parent_event_id);
                    if (!parent) continue;
                    if (!parent.exdates) parent.exdates = [];
                    if (event.original_start_time) parent.exdates.push(new Date(event.original_start_time.replace(' ', 'T')).toDateString());
                    if ((event.is_cancelled === 0 || event.is_cancelled === '0' || event.is_cancelled === false) && event.start_time) {
                        const s = new Date(event.start_time.replace(' ', 'T'));
                        const e = event.end_time ? new Date(event.end_time.replace(' ', 'T')) : new Date(s.getTime() + 3600000);
                        if (s >= startOfDay && s <= endOfDay) todayEvents.push({ ...event, instance_start: s, instance_end: e });
                        else if (s > endOfDay)                allFuture.push({ ...event, instance_start: s, instance_end: e });
                    }
                }

                for (const event of eventMap.values()) {
                    if (event.parent_event_id || !event.start_time) continue;
                    const start = new Date(event.start_time.replace(' ', 'T'));
                    if (isNaN(start)) continue;
                    const end      = event.end_time ? new Date(event.end_time.replace(' ', 'T')) : new Date(start.getTime() + 3600000);
                    const duration = end - start;
                    if (event.is_recurring === 1 || event.is_recurring === '1' || event.is_recurring === true) {
                        const days = parseDays(event.recurrence_rule);
                        if (start <= endOfDay) {
                            const d = new Date(now);
                            if (!days.length || days.includes(d.getDay())) {
                                const iStart = new Date(d);
                                iStart.setHours(start.getHours(), start.getMinutes(), 0, 0);
                                if (iStart >= startOfDay && iStart <= endOfDay && iStart >= start && !(event.exdates || []).includes(iStart.toDateString()))
                                    todayEvents.push({ ...event, instance_start: iStart, instance_end: new Date(iStart.getTime() + duration) });
                            }
                        }
                        for (let i = 1; i <= 60; i++) {
                            const df = new Date(now); df.setDate(df.getDate() + i);
                            if (!days.length || days.includes(df.getDay())) {
                                const iStart = new Date(df);
                                iStart.setHours(start.getHours(), start.getMinutes(), 0, 0);
                                if (iStart > endOfDay && iStart >= start && !(event.exdates || []).includes(iStart.toDateString())) {
                                    allFuture.push({ ...event, instance_start: iStart, instance_end: new Date(iStart.getTime() + duration) });
                                    break;
                                }
                            }
                        }
                    } else {
                        const cancelled = event.is_cancelled === 1 || event.is_cancelled === '1' || event.is_cancelled === true;
                        if (!cancelled) {
                            if (start >= startOfDay && start <= endOfDay) todayEvents.push({ ...event, instance_start: start, instance_end: end });
                            else if (start > endOfDay)                    allFuture.push({ ...event, instance_start: start, instance_end: end });
                        }
                    }
                }
                todayEvents.sort((a, b) => a.instance_start - b.instance_start);
                allFuture.sort((a, b) => a.instance_start - b.instance_start);
                setUpcomingEvents(todayEvents);
                setFutureEvents(allFuture);
            }).catch(() => {});
    }, []);

    useEffect(() => {
        if (role === 'etudiant') fetchUpcomingEvents();
    }, [fetchUpcomingEvents, role]);

    useEffect(() => {
        if (role !== 'etudiant' || !upcomingEvents.length) return;
        const id = setInterval(() => {
            const now = new Date(Date.now() + timeOffset);
            const starting = upcomingEvents.find(evt => {
                const uid = `${evt.id}-${evt.instance_start.getTime()}`;
                return now >= evt.instance_start && now < evt.instance_end && !launchedEventIds.includes(uid);
            });
            if (starting) {
                setLaunchedEventIds(prev => [...prev, `${starting.id}-${starting.instance_start.getTime()}`]);
                setCurrentActiveSession(starting);
            }
        }, 10000);
        return () => clearInterval(id);
    }, [upcomingEvents, launchedEventIds, timeOffset, role]);

    // Redirection selon rôle si sur /
    useEffect(() => {
        if (['admin', 'supertuteur'].includes(role) && location.pathname === '/') navigate('/apprendre', { replace: true });
        if (['admin', 'supertuteur'].includes(role) && location.pathname === '/admin') navigate('/apprendre', { replace: true });
        if (role === 'tuteur' && location.pathname === '/') navigate('/admin/eleves', { replace: true });
        if (role === 'professeur' && location.pathname === '/') navigate('/professeur/classes', { replace: true });
        if (role === 'parent' && location.pathname === '/') navigate('/parent/enfants', { replace: true });
    }, [role, location.pathname, navigate]);

    useEffect(() => {
        const mq = window.matchMedia('(min-width: 1024px)');
        const handler = (e) => setIsLargeScreen(e.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, []);

    const sidebarOpen = isLargeScreen || isSidebarOpen;

    const toggleChat = () => window.dispatchEvent(new CustomEvent('toggle-axio-chat'));

    const navItems = NAV[role] || NAV.etudiant;
    const badge    = ROLE_BADGE[role];

    // ─── Contenu principal selon rôle / chemin ────────────────────────────────
    const renderContent = () => {
        const p = location.pathname;
        if (p === '/profil')  return <ProfileSettings user={user} isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} onLogout={onLogout} onProfileUpdate={onProfileUpdate} embedded />;
        if (p === '/messagerie')  return <Messagerie currentUserId={user.id} userRole={role} />;
        if (role === 'professeur') {
            if (p === '/professeur/progres') return <ProfesseurProgres />;
            return <ProfesseurClasses />;
        }
        if (role === 'parent') {
            return <ParentDashboard />;
        }
        if (['admin', 'supertuteur', 'tuteur'].includes(role)) {
            const isAdmin        = role === 'admin';
            const canEditContent = role !== 'tuteur';
            if (p.startsWith('/apprendre') && p.endsWith('/edit') && canEditContent) {
                if (p.includes('/exercice/')) return <AdminSkills />;
                return <AdminContent isAdmin={isAdmin} user={user} />;
            }
            if (p.startsWith('/apprendre')) return <CourseView user={user} onExit={() => navigate('/apprendre')} defaultSubject={null} onChapterChange={() => {}} />;
            if (p === '/admin/exercices') return isAdmin ? <AdminSkills /> : null;
            if (p === '/admin/stats')        return isAdmin ? <AdminStats /> : null;
            if (p === '/admin/eleves')       return <AdminStudents isAdmin={isAdmin} userRole={role} />;
            if (p === '/admin/images')       return isAdmin ? <AdminUploads user={user} embedded /> : null;
            if (p === '/admin/medias')       return isAdmin ? <AdminMedia /> : null;
            if (p === '/admin') return canEditContent ? <AdminContent isAdmin={isAdmin} user={user} /> : null;
            return null;
        }
        return <EtudiantView user={user} upcomingEvents={upcomingEvents} futureEvents={futureEvents} timeOffset={timeOffset} />;
    };

    // ─── Lien de nav (sidebar) ────────────────────────────────────────────────
    const NavLink = ({ item }) => {
        const active = isActive(item, location.pathname);
        return (
            <Link to={item.path}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-xl transition-colors text-sm font-medium
                    ${active
                        ? 'bg-cyan-500/10 text-cyan-700 dark:text-cyan-400 border border-cyan-500/20'
                        : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-white/[0.05] hover:text-gray-900 dark:hover:text-gray-200'
                    }`}
            >
                <span className="min-w-[20px] flex items-center justify-center"><item.Icon /></span>
                {sidebarOpen && <span className="whitespace-nowrap">{item.label}</span>}
            </Link>
        );
    };

    // ─── Rendu ────────────────────────────────────────────────────────────────
    return (
        <div className="relative z-0 flex h-screen bg-gray-50 dark:bg-gray-950 text-gray-800 dark:text-gray-200 overflow-hidden font-sans transition-colors duration-300">

            {/* Halos de fond */}
            <div className="absolute inset-0 pointer-events-none -z-10">
                <div className="absolute top-[10%] left-[20%] w-[30rem] h-[30rem] bg-purple-500/10 blur-[120px] rounded-full dark:bg-purple-600/15" />
                <div className="absolute bottom-[10%] right-[20%] w-[30rem] h-[30rem] bg-cyan-500/10 blur-[120px] rounded-full dark:bg-cyan-600/15" />
            </div>

            {/* ── SIDEBAR (desktop) ──────────────────────────────────────────── */}
            <aside className={`hidden md:flex flex-col bg-white/70 dark:bg-white/[0.03] backdrop-blur-xl border-r border-gray-200 dark:border-white/[0.05] transition-all duration-300 z-20 ${sidebarOpen ? 'w-56' : 'w-[60px]'}`}>

                {/* Logo + toggle */}
                <div className="h-16 flex items-center justify-between px-3 border-b border-gray-200 dark:border-white/[0.05] shrink-0">
                    {sidebarOpen && (
                        <div className="flex items-center gap-2">
                            <AxiomusLogo height={28} />
                            <span className="text-base font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-400">Axiomus</span>
                        </div>
                    )}
                    <button onClick={() => setIsSidebarOpen(v => !v)}
                        className={`p-2 rounded-xl hover:bg-gray-200 dark:hover:bg-white/[0.1] text-gray-500 dark:text-gray-400 transition-colors mx-auto ${isLargeScreen ? 'hidden' : ''}`}>
                        {sidebarOpen ? <IconX /> : <IconMenu />}
                    </button>
                </div>

                {/* Badge rôle */}
                {sidebarOpen && badge && (
                    <div className="px-3 pt-3">
                        <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${badge.color}`}>{badge.label}</span>
                    </div>
                )}

                {/* Navigation */}
                <nav className="flex-1 py-4 flex flex-col gap-1 px-2 overflow-y-auto">
                    {navItems.map(item => <NavLink key={item.path} item={item} />)}
                </nav>

            </aside>

            {/* ── ZONE PRINCIPALE ───────────────────────────────────────────── */}
            <main className="flex-1 relative overflow-y-auto w-full pb-20 md:pb-0 flex flex-col">
                <BandeauProvider>
                    <BandeauContent user={user} location={location} navigate={navigate} onLogout={onLogout} renderContent={renderContent} />
                </BandeauProvider>
            </main>

            {/* ── BOTTOM NAV (mobile) ───────────────────────────────────────── */}
            <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white/90 dark:bg-gray-900/90 backdrop-blur-xl border-t border-gray-100 dark:border-white/[0.05] z-50 shadow-[0_-4px_20px_rgba(0,0,0,0.05)]">
                <div className="flex items-center justify-around h-16 px-2">

                    {role === 'etudiant' ? (
                        <>
                            {/* Accueil, Apprendre, [IA], Séances, Profil */}
                            {[navItems[0], navItems[1]].map(item => (
                                <Link key={item.path} to={item.path}
                                    className={`flex flex-col items-center justify-center gap-0.5 w-12 transition-colors
                                        ${isActive(item, location.pathname) ? 'text-cyan-600 dark:text-cyan-400' : 'text-gray-400 hover:text-gray-600'}`}>
                                    <item.Icon />
                                    <span className="text-[9px] font-semibold">{item.label}</span>
                                </Link>
                            ))}
                            <div className="relative -top-4">
                                <button onClick={toggleChat}
                                    className="flex items-center justify-center w-14 h-14 bg-gradient-to-r from-cyan-500 to-purple-600 text-white rounded-full shadow-lg shadow-cyan-500/30 border-4 border-gray-50 dark:border-gray-950 active:scale-95 transition-transform">
                                    <Bot className="w-7 h-7 text-white" />
                                </button>
                            </div>
                            {[navItems[2], navItems[3]].filter(Boolean).map(item => item && (
                                <Link key={item.path} to={item.path}
                                    className={`flex flex-col items-center justify-center gap-0.5 w-12 transition-colors
                                        ${isActive(item, location.pathname) ? 'text-cyan-600 dark:text-cyan-400' : 'text-gray-400 hover:text-gray-600'}`}>
                                    <item.Icon />
                                    <span className="text-[9px] font-semibold">{item.label}</span>
                                </Link>
                            ))}
                        </>
                    ) : (
                        <>
                            {/* Pour prof/admin : tous les items de nav + settings */}
                            {[...navItems, { path: '/profil', label: 'Profil', Icon: IconUser }].map(item => (
                                <Link key={item.path} to={item.path}
                                    className={`flex flex-col items-center justify-center gap-0.5 flex-1 transition-colors
                                        ${isActive(item, location.pathname) ? 'text-cyan-600 dark:text-cyan-400' : 'text-gray-400 hover:text-gray-600'}`}>
                                    <item.Icon />
                                    <span className="text-[9px] font-semibold leading-tight text-center">{item.label}</span>
                                </Link>
                            ))}
                        </>
                    )}
                </div>
            </nav>

            {/* ── Popup séance automatique ──────────────────────────────────── */}
            {currentActiveSession && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
                    <div className="bg-white dark:bg-gray-900 p-8 rounded-3xl shadow-2xl max-w-md w-full text-center border border-gray-200 dark:border-gray-800">
                        <div className="w-20 h-20 bg-purple-500/20 text-purple-600 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
                            <Calendar className="w-10 h-10 text-purple-500" />
                        </div>
                        <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">Ta séance commence !</h2>
                        <p className="text-gray-600 dark:text-gray-400 mb-6 font-medium text-lg">{currentActiveSession.title}</p>
                        <div className="flex flex-col gap-3">
                            <button onClick={() => {
                                window.dispatchEvent(new CustomEvent('start-agenda-session', { detail: { id: currentActiveSession.id } }));
                                setCurrentActiveSession(null);
                                navigate('/');
                            }} className="w-full py-4 rounded-xl font-bold text-white bg-purple-600 hover:bg-purple-700 shadow-lg shadow-purple-500/30 transition-all">
                                Rejoindre la séance
                            </button>
                            <button onClick={() => setCurrentActiveSession(null)}
                                className="w-full py-3 rounded-xl font-bold text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all">
                                Plus tard
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Dashboard;
